/* eslint-disable max-len */
export function NewfrontLogo() {
  return (
    <svg width="120" height="23" viewBox="0 0 120 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.796875 5.30469H2.93687L11.6291 13.6647V5.30469H13.9847V16.9158H11.828L3.15243 8.5558V16.9158H0.796875V5.30469Z"
        fill="#F028B8"
      />
      <path
        d="M16.1406 5.30469H27.3373V7.27802H18.4962V10.1236H27.3373V12.0969H18.4962V14.9258H27.3373V16.9158H16.1406V5.30469Z"
        fill="#F028B8"
      />
      <path
        d="M28.6992 5.30469H31.2537L34.3392 13.8636L37.2581 5.30469H39.5648L42.467 13.8636L45.5692 5.30469H48.1237L43.827 16.9158H41.1737L38.4203 8.73802L35.6337 16.9158H32.9959L28.6992 5.30469Z"
        fill="#F028B8"
      />
      <path
        d="M91.5371 5.30469H93.6771L102.368 13.6647V5.30469H104.724V16.9158H102.568L93.8927 8.5558V16.9158H91.5371V5.30469Z"
        fill="#F028B8"
      />
      <path d="M111.687 7.27802H106.545V5.30469H119.202V7.27802H114.043V16.9158H111.687V7.27802Z" fill="#F028B8" />
      <path
        d="M72.5048 12.048C74.1048 11.7736 75.3226 10.3802 75.3226 8.70135C75.3226 6.8258 73.8015 5.30469 71.9259 5.30469H62.8359V16.9158H65.1582V12.0969H70.0826L73.3326 16.9158H75.787L72.5037 12.0469L72.5048 12.048ZM65.1759 10.1236L65.1593 7.27913H71.6893C72.4748 7.27913 73.1115 7.9158 73.1115 8.70135C73.1115 9.48691 72.4748 10.1236 71.6893 10.1236H65.1759Z"
        fill="#F028B8"
      />
      <path
        d="M49.4863 5.30469H60.6841V7.27802H51.8419V10.1236H60.6841V12.0969H51.8419V16.9158H49.4863V5.30469Z"
        fill="#F028B8"
      />
      <path
        d="M76.5508 11.1111C76.5508 7.55336 79.2674 5.19336 83.3741 5.19336C87.4808 5.19336 90.1974 7.55447 90.1974 11.1111C90.1974 14.6678 87.4652 17.0289 83.3741 17.0289C79.283 17.0289 76.5508 14.6678 76.5508 11.1111ZM87.9019 11.1111C87.9019 8.65336 86.0908 7.1178 83.3741 7.1178C80.6574 7.1178 78.8463 8.65336 78.8463 11.1111C78.8463 13.5689 80.6574 15.0889 83.3741 15.0889C86.0908 15.0889 87.9019 13.5689 87.9019 11.1111Z"
        fill="#F028B8"
      />
    </svg>
  );
}
